import style from './css.module.scss'

const Notfound = () => {
	return (
		<div className={style.notfound}>
			<span>404 not found</span>
		</div>
	)
}

export default Notfound
